import { useEffect, useState } from "react";
import axios from "axios";
import StripePayment from "./StripePayment";

export default function PayPage() {
  const [gateway, setGateway] = useState(null);
  const token = new URLSearchParams(window.location.search).get("token");

  useEffect(() => {
    if (!token) return;

    axios
      .get(`https://booktrip4me.com/api/payment-details.php?token=${token}`)
      .then((res) => {
        const data = res.data;

        if (!data || !data.gateway) {
          alert("Invalid payment configuration");
          return;
        }

        // 🔹 NMI → redirect to static hosted payment page
        if (data.gateway.toLowerCase() === "nmi") {
          window.location.href = `/Paymentpage.html?token=${token}`;
          return;
        }

        // 🔹 Stripe → stay in React
        if (data.gateway.toLowerCase() === "stripe") {
          setGateway("stripe");
        }
      })
      .catch(() => {
        alert("Invalid or expired payment link");
      });
  }, [token]);

  /* ================= UI STATES ================= */

  if (!token) {
    return (
      <p className="text-center mt-20 text-red-500">
        Invalid payment link
      </p>
    );
  }

  if (!gateway) {
    return (
      <p className="text-center mt-20 text-gray-500">
        Initializing secure payment…
      </p>
    );
  }

  /* ================= STRIPE FLOW ================= */

  return gateway === "stripe" ? <StripePayment /> : null;
}
